export const tilesConstant = {
    childHeaderText: 'Annual Preventive Plan',
};
